// extracted by mini-css-extract-plugin
export default {"container":"tJ-z","timeTop":"uJ-z","timeCountdown":"vJ-z","cta":"wJ-z","disabled":"xJ-z","product":"yJ-z"};